import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { apiOrganization } from "src/services/Api/Organization/apiOrganization";
import { AlertsApi } from "src/services/Api/Organization/types";
import useFlash from "go-alert/AlertMessage";
import Header from "go-app/components/Header";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { DashboardAlertSection, DashboardProductsSection } from "./components";

const OrganizationDashboardPage = () => {
	const { t } = useTranslation();
	const { addFlash } = useFlash();
	const [isLoading, setIsLoading] = useState(false);
	const [alertsData, setAlertsData] = useState<AlertsApi>();
	const { handleChangeTabTitle } = useBrowserTabTitle();

	useEffect(() => {
		handleChangeTabTitle(t("modules.dashboard.header.title"));
	}, []);

	useEffect(() => {
		const loadAlertsData = async () => {
			setIsLoading(true);

			try {
				const alertsApiResponse = await apiOrganization.getAlertsData();
				setAlertsData(alertsApiResponse);
			} catch (err) {
				handleError.alert(err, addFlash);
			}

			setIsLoading(false);
		};

		loadAlertsData();
	}, [t, addFlash]);

	return (
		<div className="content">
			<Header title={t("modules.dashboard.header.title")} />
			<div className="d-flex flex-md-nowrap flex-wrap gap-4 w-100 align-items-start mb-6 dashboard">
				<DashboardAlertSection isLoading={isLoading} alertsData={alertsData} />
				<DashboardProductsSection isLoading={isLoading} alertsData={alertsData} />
			</div>
		</div>
	);
};

export default OrganizationDashboardPage;
